<ng-container *ngIf="urlType === 'WMS'">
  <phoenix-wms-component [url]="url"></phoenix-wms-component>
</ng-container>
<ng-container *ngIf="urlType === 'WMTS'">
  <phoenix-wmts-component [url]="url"></phoenix-wmts-component>
</ng-container>
<ng-container *ngIf="urlType === 'WFS'">
  <phoenix-wfs-component [url]="url"></phoenix-wfs-component>
</ng-container>
<ng-container *ngIf="urlType === 'ARCGIS'">
  <phoenix-arcgis-feature-component [url]="url"></phoenix-arcgis-feature-component>
</ng-container>
<ng-container *ngIf="urlType === 'VectorTile'">
  <phoenix-vector-tile-component [url]="url"></phoenix-vector-tile-component>
</ng-container>
<ng-container *ngIf="urlType === 'XYZ'">
  <phoenix-xyz-component [url]="url"></phoenix-xyz-component>
</ng-container>
